"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _ = require("../..");

var css = _interopRequireWildcard(require("./InfiniteScroll.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const InfiniteScrollComponent = /*#__PURE__*/React.forwardRef(({
  items = [],
  pageSize = 10,
  libProps,
  numberVisibleItemsToPaginate = 1,
  onNextPage,
  onItemVisible,
  debounceTime = 500,
  ...props
}, ref) => {
  const [page, setPage] = React.useState(1);
  React.useEffect(() => {
    if (items) {
      _.Logger.log('InfiniteScroll', 'page reset to initial (1)');

      setPage(1);
    }
  }, [items]);
  const childrenList = items.slice(0, pageSize * page);
  const lastPage = childrenList.length === items.length;
  const setPageHandler = (0, _debounce.default)(() => {
    // if this is not last page
    if (!lastPage) {
      const newPage = page + 1;

      if (onNextPage) {
        _.Logger.log('InfiniteScroll', 'onNextPage is triggered');

        onNextPage(page, pageSize);
      }

      _.Logger.log('InfiniteScroll', 'next page', newPage);

      setPage(newPage);
    }
  }, debounceTime, {
    leading: true,
    trailing: false
  });
  return (0, _pragma.createFelaElement)(_.View, _extends({
    flex: true,
    flexDirection: "column",
    overflow: "auto",
    css: css.container,
    ref: ref
  }, props), childrenList.map(({
    element,
    id
  }, index) => {
    const paginationHandler = visible => {
      if (onItemVisible) onItemVisible({
        id,
        index,
        visible
      });

      if (visible) {
        const isLastItem = index === childrenList.length - numberVisibleItemsToPaginate;

        if (isLastItem) {
          _.Logger.log('InfiniteScroll', "last item ".concat(id, " triggers setPageHandler"));

          setPageHandler();
        }
      }
    };

    return (0, _pragma.createFelaElement)(_reactIntersectionObserver.InView, _extends({
      key: id,
      triggerOnce: true,
      onChange: paginationHandler
    }, libProps), element);
  }));
});
const InfiniteScroll = /*#__PURE__*/React.memo(InfiniteScrollComponent);
InfiniteScroll.displayName = 'InfiniteScroll';
var _default = InfiniteScroll;
exports.default = _default;
//# sourceMappingURL=InfiniteScroll.js.map